import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { FaHome, FaSlidersH, FaHeart, FaUser, FaChartBar, FaReact, FaRoute } from 'react-icons/fa';
import { LuCalendarRange, LuCakeSlice } from 'react-icons/lu';
import { getFirebase } from '@services/firebase';
import { useEnquiryBadge } from '@hooks/useEnquiryBadge';

const BottomMenu = ({ userRole }) => {
  const { auth } = getFirebase();
  const [user] = useAuthState(auth);
  const isSuperOrAdmin = userRole === 'Super' || userRole === 'Admin';
  const isMoverOrAdmin = userRole === 'Mover' || userRole === 'Admin';
  const isMover = userRole === 'Mover';
  const isBuyer = userRole === 'Buyer';
  const isUser = userRole === 'User';
  const isAdmin = userRole === 'Admin';
  const isSuper = userRole === 'Super';
  const hasEnquiryUpdate = useEnquiryBadge(user, userRole);

  return (
    <div className="bottom-menu">
      {!user||isUser ? null : (
        <NavLink to={isMoverOrAdmin ? "/engage" : isSuper ? "/profile" : "/"} className={({ isActive }) => `menu-item${isActive ? ' menu-item--active' : ''}`}>
          {isMoverOrAdmin ? <FaReact /> : isSuper ? <FaUser /> : <FaHome />}
          <span>{isMoverOrAdmin ? "Engage" : isSuper ? "Profile" : "Home"}</span>
        </NavLink>
      )}
      {!user||isUser ? null : (
        <NavLink to={isMover ? "/delroute" : isAdmin ? "/analytics" : "/custom"} className={({ isActive }) => `menu-item${isActive ? ' menu-item--active' : ''}`}>
          {isMover ? <FaRoute /> : isAdmin ? <FaChartBar /> :<FaSlidersH />}
          <span>{isMover ? "Route" : isAdmin ? "Analytics" : "Custom"}</span>
        </NavLink>
      )}
      {!user||isUser ? null : (
        <NavLink to={isMover||isSuperOrAdmin ? "/organize" : "/favourite"} className={({ isActive }) => `menu-item${isActive ? ' menu-item--active' : ''}`}>
          {isMover||isSuperOrAdmin ? <LuCalendarRange /> : <FaHeart />}
          <span>{isMover||isSuperOrAdmin ? "Organize" : "Favourite"}</span>
        </NavLink>
      )}
      <NavLink to={isSuper ? '/enquiry' : user ? '/profile' : '/login'} className={({ isActive }) => `menu-item${isActive ? ' menu-item--active' : ''}`} style={{ position: 'relative' }}>
        {isSuper ? <LuCakeSlice /> : <FaUser />}
        {isSuper && hasEnquiryUpdate && (
          <span style={{
            position: 'absolute',
            top: '0px',
            right: '0px',
            width: '9px',
            height: '9px',
            backgroundColor: '#4caf50',
            borderRadius: '50%',
            border: '1.5px solid #fff',
            display: 'block',
          }} />
        )}
        <span>{isSuper ? 'Enquiry' : user ? 'Profile' : 'Login'}</span>
      </NavLink>
    </div>
  );
};

export default BottomMenu;